import * as _ from 'lodash';
import moment from 'moment';
import { getValueWithoutLeadingSpaces } from '../../../utilities';
import { STATUS_CODE } from '../../../utilities/statusUtils';
import { REAL_ADMIN_R, REAL_AU_R } from '../../../roleaccess/adGroups';

const hasDeskAuditDateAccess = (userRole = []) => (
  userRole.includes(REAL_AU_R) || userRole.includes(REAL_ADMIN_R)
);

const isEmptyValue = (value) => value === '' || _.isNil(value);

const validatePositiveNumber = (value, requiredMessage) => {
  if (isEmptyValue(value)) {
    return requiredMessage;
  }
  if (_.isNaN(_.toNumber(value))) {
    return 'Must be number';
  }
  if (_.toNumber(value) < 0) {
    return 'Must be a positive number';
  }
  return null;
};

const validateClosingName = (closingName, maxLength = 50) => {
  if (!closingName) {
    return 'Project name required';
  }
  if (closingName.length > maxLength) {
    return `Project Name must be ${maxLength} characters or less`;
  }
  if (getValueWithoutLeadingSpaces(closingName) === '') {
    return 'Project Name only contains white spaces';
  }
  return null;
};

const validateClosingStartTs = (closingStartTs) => {
  if (_.isEmpty(closingStartTs) || _.isNull(closingStartTs) || _.isNaN(closingStartTs)) {
    return 'Closing date required';
  }
  return null;
};

export const validateProjectDetails = (values, props) => {
  const errors = {};
  const isEditForm = props.form === 'projectEdit';

  /* Validate closing_name with 50 character limit for all modes */
  const closingNameError = validateClosingName(values.closing_name);
  if (closingNameError) {
    errors.closing_name = closingNameError;
  }

  if (isEditForm) {
    const closingStartError = validateClosingStartTs(values.closing_start_ts);
    if (closingStartError) {
      errors.closing_start_ts = closingStartError;
    }
  }

  const projectSeqError = validatePositiveNumber(values.project_seq_nbr, 'Project sequence number required');
  if (projectSeqError) {
    errors.project_seq_nbr = projectSeqError;
  }

  const sellerCountError = validatePositiveNumber(values.seller_count, 'sellers count required');
  if (sellerCountError) {
    errors.seller_count = sellerCountError;
  }

  const parcelCountError = validatePositiveNumber(values.parcel_count, 'Parcels count required');
  if (parcelCountError) {
    errors.parcel_count = parcelCountError;
  }

  if (isEmptyValue(values.store_nbr)) {
    errors.store_nbr = 'Store number required';
  }

  if (values.closing_start_ts && !moment(values.closing_start_ts).isValid()) {
    errors.closing_start_ts = 'Invalid Date Format';
  }

  /* Validate desk_audit_closing_actual_date format */
  if (values.desk_audit_closing_actual_date && !moment(values.desk_audit_closing_actual_date).isValid()) {
    errors.desk_audit_closing_actual_date = 'Invalid Date Format';
  }

  /* Desk Audit Closing Actual Date is required when status is Closed (auditor only) */
  if (isEditForm) {
    const userRole = props.userRole;
    const canEditDeskAuditDate = userRole && userRole.includes && hasDeskAuditDateAccess(userRole);
    const statusCode = values.status_code_desc && values.status_code_desc.value;
    if (canEditDeskAuditDate && statusCode === STATUS_CODE.CLOSED && !values.desk_audit_closing_actual_date) {
      errors.desk_audit_closing_actual_date = 'Desk Audit Closing Actual Date is required for Closed status';
    }
  }

  return errors;
};
